import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import ChildHeader from '../../components/ChildHeader';
import ChildPages from '../../components/ChildPages';
import ChartCard from '../../components/ChartCard';
import Statistics from '../../components/Statistics';
import ResponsiveFooter from '../../components/ResponsiveFooter';


import { Container, Content } from './styles';
import { useListChildren } from '../../hooks/ParentContext'
import { useAuth } from '../../hooks/AuthContext'
import api from '../../services/api';
import sleeplessIcon from '../../assets/physical/sleepless.png';


const SleepHabits = () => {
  const token = localStorage.getItem("@Ocariot:token");
  const { selectedOne } = useListChildren();
  const { user } = useAuth();
  const [date, setDate] = useState()
  const [stats, setStats] = useState();

  const getData = () => {

    let dateReq = new Date();
    const dd = String(dateReq.getDate()).padStart(2, '0');
    const mm = String(dateReq.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = dateReq.getFullYear();
    dateReq = yyyy + '-' + mm + '-' + dd
    
    let path = `statistics/sleep/${selectedOne._id}/${dateReq}/${dateReq}/`
    // let path = `statistics/sleep/${selectedOne._id}/2021-07-13/2021-07-13/`
    api.get(path, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        sort: 'day'
      }
    }).then((res) => {
      let hoursW = ("0" + String(Math.floor(res.data.data[0].wakeMinutes / 60))).substr(-2)
      let hoursR = ("0" + String(Math.floor(res.data.data[0].remMinutes / 60))).substr(-2)
      let hoursD = ("0" + String(Math.floor(res.data.data[0].deepMinutes / 60))).substr(-2)
      let hoursL = ("0" + String(Math.floor(res.data.data[0].lightMinutes / 60))).substr(-2)
      setStats({
        wakeMinutes: (("0" + String(Math.floor(res.data.data[0].wakeMinutes / 60))).substr(-2) + 'hs' + ("0" + String(Math.round(((res.data.data[0].wakeMinutes / 60) - hoursW) * 60))).substr(-2) + 'mins'),
        remMinutes: (("0" + String(Math.floor(res.data.data[0].remMinutes / 60))).substr(-2) + 'hs' + ("0" + String(Math.round(((res.data.data[0].remMinutes / 60) - hoursR) * 60))).substr(-2) + 'mins'),
        deepMinutes: (("0" + String(Math.floor(res.data.data[0].deepMinutes / 60))).substr(-2) + 'hs' + ("0" + String(Math.round(((res.data.data[0].deepMinutes / 60) - hoursD) * 60))).substr(-2) + 'mins'),
        lightMinutes: (("0" + String(Math.floor(res.data.data[0].lightMinutes / 60))).substr(-2) + 'hs' + ("0" + String(Math.round(((res.data.data[0].lightMinutes / 60) - hoursL) * 60))).substr(-2) + 'mins')
      })

    }).catch((err) => {
      console.log(err);
    });

  }

  useEffect(() => {
    let date = new Date();
    setDate(String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear())
    getData();
  }, [selectedOne])
  return (
    <Container>
      <Content>
      {user.type == 2 ? (
          <div className="first-header-line">
            <ChildHeader />
            <Link to="dashboard">Selecionar outra criança</Link>
          </div>
        ) : (
          <div className="first-header-line">
            <ChildHeader />
          </div>
        )}

        <div className="body">
          <div className="pages-child">
            <ChildPages active="sleep" />
          </div>
          <div className="charts-body">
            <div className="main-chart">
              <p>Acompanhe o progresso do participante relacionado aos parâmetros de hábitos de sonos</p>
              <ChartCard
                name="Hábitos de sono"
                route="sleep"
                labels={["Sem sono", "Sono REM", "Sono profundo", "Sono leve"]}
              />
            </div>

            <br />
            <div className="secondary-charts">
              <p>Estátiscas do dia atual: <strong>{date}</strong></p>
              <div className="atual-day">
                <Statistics icon={sleeplessIcon} stringValue={stats ? stats.wakeMinutes : '00hs00mins'} name="Sem sono" />
                <Statistics icon={sleeplessIcon} stringValue={stats ? stats.remMinutes : '00hs00mins'} name="Sono REM" />
                <Statistics icon={sleeplessIcon} stringValue={stats ? stats.deepMinutes : '00hs00mins'} name="Sono profundo" />
                <Statistics icon={sleeplessIcon} stringValue={stats ? stats.lightMinutes : '00hs00mins'} name="Sono leve" />
                <ResponsiveFooter />
              </div>
            </div>
          </div>
        </div>
      </Content>
    </Container>
  );
}

export default SleepHabits;